import { render, staticRenderFns } from "./SortingMetricReport.vue?vue&type=template&id=ab573a5a&scoped=true"
import script from "./SortingMetricReport.vue?vue&type=script&lang=js"
export * from "./SortingMetricReport.vue?vue&type=script&lang=js"
import style0 from "./SortingMetricReport.vue?vue&type=style&index=0&id=ab573a5a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab573a5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab573a5a')) {
      api.createRecord('ab573a5a', component.options)
    } else {
      api.reload('ab573a5a', component.options)
    }
    module.hot.accept("./SortingMetricReport.vue?vue&type=template&id=ab573a5a&scoped=true", function () {
      api.rerender('ab573a5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sorting/SortingMetricReport.vue"
export default component.exports